module.exports = __webpack_public_path__ + "static/vSHWBX8iTjOVGTiaPAHy4Q_thumb_36a4-b491c25b4681050d755a26d23f3764d4.jpg";